import { LoanCrud } from "./loanCrud";

export default function TeamLoan(){
    return <LoanCrud name="团队按揭" type="team" router="teamLoan" />
}